import { Routes } from '@angular/router';
import { businessGroupsResolver } from './core/pages/view-templates/business-groups.resolver';
import { docTypesResolver } from './core/pages/view-templates/doc-types.resolver';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./core/pages/launch-entry/launch-entry.component').then(
        (m) => m.LaunchEntryComponent,
      ),
    pathMatch: 'full',
  },
  {
    path: 'launch/:id',
    loadComponent: () =>
      import('./core/pages/launch-entry/launch-entry.component').then(
        (m) => m.LaunchEntryComponent,
      ),
  },
  {
    path: 'templates',
    loadComponent: () =>
      import('./core/pages/view-templates/view-templates.component').then(m => m.ViewTemplatesComponent),
    resolve: { businessGroups: businessGroupsResolver, docTypes: docTypesResolver },
  },
  {
    path: 'pdf-preview',
    loadComponent: () =>
      import('./core/pages/pdf-preview/pdf-preview.component').then(m => m.PdfPreviewComponent)
  }
  ,
  {
    path: 'form',
    loadComponent: () =>
      import('./core/pages/form/form.component').then(m => m.FormComponent)
  },
  {
    path: 'test',
    loadComponent: () =>
      import('./core/pages/test/test.component').then(m => m.TestComponent)
  },
  {
    path: '**',
    redirectTo: '',
  },
];
